<template>
  <v-app>
    <v-container fluid pa-0>
              <v-row align="center" justify="center"
                  style="height:100vh" dense>
                  <v-col cols="12" lg="12" md="12" class="grey lighten-2 fill-height d-flex flex-column justify-center align-center">
                    <v-carousel height="100vh" cycle style="background-color:grey" hide-delimiters>
                      <v-carousel-item v-for="(item, i) in items" :key="i">
                        <v-img :src="item.src" height="100%"></v-img>
                      </v-carousel-item>
                    </v-carousel>
                    <div class="v-overlay v-overlay--active theme--dark"><div class="v-overlay__scrim" style="opacity: 0.46; background-color: rgb(33, 33, 33); border-color: rgb(33, 33, 33);"></div><div class="v-overlay__content"></div></div>
                    <v-card class="justify-center" width="350" style="position:absolute" :loading="loadingLogin">
                      <v-col cols="12" md="12" lg="12" sm="12" class="text-center">
                        <v-img :src="require(`@/assets/logoG.jpeg`)" height="150">
                        </v-img>
                        <h3>Inicio Sesión Portal Proveedores</h3>
                        <v-col cols="12">
                          <v-form @submit.prevent="">
                            <v-text-field v-model="rfc" label="RFC" filled required></v-text-field>
                            <v-text-field v-model="email" label="Usuario" filled required></v-text-field>
                            <v-text-field v-model="password" label="Contraseña" filled :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                              @click:append="showPass = !showPass" required :type="showPass ? 'text' : 'password'"></v-text-field>
                            <div class="text-center">
                              <v-btn type="submit" rounded color="orange"  @click="submit()" style="width: 100%;" :disabled="loadingLogin">
                                Ingresar
                              </v-btn>
                            </div>
                            <div>
                              <v-row>
                                <v-col>
                                  <v-btn type="submit" class="mt-10" outlined color="green" dark rounded @click="registerAccount()" style="width: 100%;">
                                    Registrate
                                  </v-btn>
                                </v-col>
                                <v-col>
                                  <v-btn type="submit" class="mt-10" outlined color="blue" rounded dark @click="dialogVideo = true" style="width: 100%;">
                                    Ver video
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </div>
                            <div>
                              <v-btn type="submit" class="mt-10" outlined color="blue" rounded dark @click="resetPass()" style="width: 100%;">
                                  Recuperar contraseña
                              </v-btn>
                            </div>
                          </v-form>
                        </v-col>
                      </v-col>
                    </v-card>
                  </v-col>
              </v-row>
    </v-container>

    <div class="text-center">
      <v-dialog v-model="dialogSendEmail" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Recuperar contraseña
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" class="ma-0">
                <v-text-field dense v-model="emailSend" label="Correo" outlined :readonly="lectura">
                </v-text-field>
              </v-col>
            </v-row>
            <v-alert type="error" :value="alert" dense transition="scale-transition">
              {{ mensajeAlert }}
            </v-alert>
            <v-alert type="success" :value="alertS" dense transition="scale-transition" dismissible>
                {{ mensajeAlert }}
              </v-alert>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialogSendEmail = false">
              Cancelar
            </v-btn>
            <v-btn color="info" @click="sendEmail()" :disabled="lectura">
              Enviar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-dialog v-model="dialogR" width="900" scrollable persistent>
          <v-card :loading="loadingB">
            <v-card-title class="text-h5 grey lighten-2">
              Formulario de registro
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation >
                <v-text-field v-model="rfcR" label="RFC" :rules="rfcRules" required append-icon="mdi-file-find" @click:append="buscarByRfc()" ></v-text-field>
                <v-text-field v-model="nameR" :rules="nameRules" label="Nombre completo" required :disabled="!validRFC" readonly></v-text-field>
                <v-text-field v-model="emailR" :rules="emailRules" label="Correo" required :disabled="!validRFC"></v-text-field>
                <v-text-field v-model="userR" label="Usuario" required :disabled="!validRFC" ></v-text-field>
                <v-text-field v-model="passR" label="Contraseña" required :disabled="!validRFC" :append-icon="showPassUp ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassUp = !showPassUp"
                    :type="showPassUp ? 'text' : 'password'"></v-text-field>
                <v-text-field v-model="passRC" label="Confirmar contraseña" required :disabled="!validRFC" :append-icon="showPassConf ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassConf = !showPassConf"
                    :type="showPassConf ? 'text' : 'password'"></v-text-field>
                <v-row>
                  <v-col md="6">
                    <v-file-input accept="application/pdf" label="ACTA CONSTITUTIVA" v-model="actaConst" :disabled="!validRFC"></v-file-input>
                  </v-col>
                  <v-col md="6">
                    <v-file-input accept="application/pdf" label="INE DEL REPRESENTANTE LEGAL" v-model="ineRep" :disabled="!validRFC"></v-file-input>
                  </v-col>
                  <v-col md="6">
                      <v-file-input accept="application/pdf" label="PODER NOTARIAL" v-model="poderNota" :disabled="!validRFC"></v-file-input>
                  </v-col>
                  <v-col md="6">
                      <v-file-input accept="application/pdf" label="CARTA DE OPINION DE CUMPLIMIENTO" v-model="cartaOpinion" :disabled="!validRFC"></v-file-input>
                  </v-col>
                  <v-col md="6">
                      <v-file-input accept="application/pdf" label="COMPROBANTE DE DOMICILIO" v-model="compDomicilio" :disabled="!validRFC"></v-file-input>
                  </v-col>
                  <v-col md="6">
                      <v-file-input accept="application/pdf" label="CONSTANCIA DE SITUACION FISCAL" v-model="constSituacionFiscal" :disabled="!validRFC"></v-file-input>
                  </v-col>
                  <v-col md="6">
                      <v-file-input accept="application/pdf" label="CARATULA BANCARIA" v-model="caratulaBanc" :disabled="!validRFC"></v-file-input>
                  </v-col>
                  <v-col md="6">
                      <v-file-input accept="application/pdf" label="CONTRATOS" v-model="contratos" :disabled="!validRFC"></v-file-input>
                  </v-col>
                   <v-checkbox v-model="checkbox" :rules="[v => !!v || 'Debe aceptar los terminos y condiciones continuar !']" label="Aceptar terminos y condiciones" required :disabled="!validRFC"></v-checkbox> <a href="" style="margin-top:16px;margin-left:10px">Ver más</a>
                </v-row>
                <v-btn :disabled="loadingRegister" color="success" class="mr-4" @click="registerUser()" :loading="loadingRegister">
                  Registrar
                </v-btn>
                <v-btn color="primary" text class="mr-4" @click="dialogR = false">
                  Cancelar
                </v-btn>
              </v-form>
              <br>
              <v-divider></v-divider>
              <v-alert type="error" :value="alert" dense transition="scale-transition" dismissible>
                {{ mensajeAlert }}
              </v-alert>

            </v-card-text>
          </v-card>
        </v-dialog>

        <div class="text-center">
        <v-dialog v-model="dialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Actualizar Contraseña
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" class="ma-0">
                  <v-text-field dense v-model="updateP" label="Contraseña"
                    :append-icon="showPassUp ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassUp = !showPassUp"
                    :type="showPassUp ? 'text' : 'password'">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" class="ma-0">
                  <v-text-field dense v-model="confirmP" label="Confirmar Contraseña"
                    :append-icon="showPassConf ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassConf = !showPassConf"
                    :type="showPassConf ? 'text' : 'password'">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-alert type="error" :value="alert" dense transition="scale-transition">
                {{ mensajeAlert }}
              </v-alert>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialog = false">
                Cancelar
              </v-btn>
              <v-btn color="info" @click="sendNewPass()" :disabled="disabled">
                Actualizar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <v-snackbar
      color="red"
        v-model="snackbar"
      >
        {{ mensajeSnack }}

        <template v-slot:action="{ attrs }">
          <v-btn
            color="pink"
            text
            v-bind="attrs"
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>

      <v-dialog
        v-model="dialogVideo"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar
            dark
            color="primary"
          >
            <v-btn
              icon
              dark
              @click="pausarVideo()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Video tutorial de registro</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
            </v-toolbar-items>
          </v-toolbar>
           <iframe ref="videoIframe" style="width:100%" height="580" src="https://novacontrol.io/wp-content/uploads/2023/10/video1-crear-cuenta.mp4" frameborder="0" allow="accelerometer stop; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </v-card>
      </v-dialog>
  </v-app>



</template>

<script>
import axios from 'axios';
export default {
  components: {
  },
  data: () => ({
    snackbar: false,
    mensajeSnack:'',
    validRFC: false,
    loadingB: false,
    loadingLogin: false,
    loadingRegister: false,
    dialogVideo:false,
    rfc:'',
    email: '',
    passR: '',
    passRC:'',
    password: '',
    showPass: false,
    dialog: false,
    showPassUp: false,
    showPassConf: false,
    alert: false,
    idSend: '',
    overlay: true,
    dialogR: false,
    rfcR:'',
    userR: '',
    tipoR: 0,
    proveedor_id: 0,
    dialogSendEmail: false,
    emailSend: '',
    lectura: false,
    //docs
    actaConst: [],
    ineRep: [],
    poderNota: [],
    cartaOpinion: [],
    compDomicilio: [],
    constSituacionFiscal: [],
    caratulaBanc: [],
    contratos: [],
    items: [
      {
        src: 'https://alogistics.mx/img/slider-2.jpg',
      },
      {
        src: 'https://alogistics.mx/img/slider-4.jpg',
      },
      {
        src: 'https://alogistics.mx/img/slider-3.jpg',
      },
    ],
    rules: [v => v.length <= 8 || 'Max 8 Caracteres'],
    updateP: '',
    confirmP: '',
    mensajeAlert: '',
    disabled: false,
    valid: false,
    nameR: '',
    alertS:false,
    nameRules: [
      v => !!v || 'El nombre es requerido'
    ],
    emailR: '',
    emailRules: [
      v => !!v || 'El correo es requerido',
      v => /.+@.+\..+/.test(v) || 'Correo Invalido',
    ],
    rfcRules: [
      v => !!v || 'RFC es requerido',
    ],
    checkbox: false,
    tieneDocs:false
  }),
  computed: {
  },
  methods: {
    async submit() {
      var user = {
        rfc:this.rfc,
        usuario: this.email,
        contrasenia:this.password
      }
      this.loadingLogin = true
      try {
        await axios.post('/login', user)
          .then(response => {
            const { data } = response
            const { success, mensaje } = data
            var isFirts = false
            this.loadingLogin = false
            if (success) {
              if (isFirts) {
                this.updatePass(data.data.id)
              } else {
                localStorage.clear()
                localStorage.setItem('login', success)
                localStorage.setItem('tipoUser', data.data.tipo)
                localStorage.setItem('nombre', data.data.nombre)
                localStorage.setItem('email', data.data.correo)
                localStorage.setItem('id', data.data.id)
                localStorage.setItem('tipo_id', data.data.tipo_id)
                localStorage.setItem('rfc', data.data.rfc)
                localStorage.setItem('proveedor_id', data.data.proveedor_id)
                this.goToDash()
              }
            } else {
              this.mensajeError(mensaje)
            }
          })
      } catch (e) {
        this.loadingLogin = false
        this.mensajeError('Ocurrio un error con la conexión')
      }
    },
    clear() {
      // you can use this method to clear login form
      this.email = ''
      this.password = ''
    },
    mensajeError(mensaje) {
      Swal.fire({
        icon: 'error',
        title: 'Mensaje',
        text: mensaje,
      })
    },
    goToDash() {
      this.$router.push('/paginas/viajes')
    },
    updatePass(id) {
      this.dialog = true
    },
    async sendNewPass() {
      if (this.confirmP === '') {
        this.showAlert('Debe Confirmar su contraseña')
          return
      }
      if (this.updateP == '') {
        this.showAlert('Se necesita una nueva contraseña')
        return
      }
      await axios.post('/reset-password/' + this.$route.query.token, { contrasenia: this.updateP }).then(response => {
        const { data } = response
        const { message, success } = data

        if (success) {
          Swal.fire(
            'Exito!',
            message,
            'success'
          )
        } else {
          Swal.fire(
            'Upss!',
            message,
            'error'
          )
          return
        }
        this.dialog = false
      })
    },
    showAlert(mensaje) {
      this.alert = true
      this.alertS = false
      this.mensajeAlert = mensaje
    },
    showAlertS(mensaje) {
      this.alertS = true
      this.alert = false
      this.mensajeAlert = mensaje
    },
    registerAccount() {
      this.dialogR = true
      this.reset()
    },
    validate() {
      this.$refs.form.validate()
    },
    reset() {
      this.rfcR  = ''
      this.nameR = ''
      this.emailR = ''
      this.passR = ''
      this.passRC = ''
      this.checkbox = false
      this.userR = ''
      this.actaCons = []
      this.ineRe = []
      this.poderNot = []
      this.cartaOpinion = []
      this.compDomicilio = []
      this.constSituacionFiscal = []
      this.caratulaBank = []
      this.contratos = []
    },
    async buscarByRfc() {
      if (this.rfcR === '') return;
      this.loadingB = true
      await axios.post('/proveedores/buscar', { rfc: this.rfcR }).then(resp => {
        const { data } = resp
        this.validRFC = data.success
        if (data.success) {
          this.nameR = data.data.nombre_proveedor
          if (data.data.modulo_origen === 'TERCE') {
            this.tipoR = 1
          } else {
            this.tipoR = 2
          }
          this.proveedor_id = data.data.id_proveedor
          this.checkDocs()
        }
        this.loadingB = false
      })
    },
    async checkDocs() {
      try {
        await axios.post('/usuario/checkDocs', { proveedor_id: this.proveedor_id }).then(resp => {
          const { data } = resp
          this.tieneDocs = data
        })
      } catch (e) {
        this.tieneDocs = false
      }
    },
    async registerUser() {

      if (!this.tieneDocs) {
        if (this.actaConst === undefined || this.actaConst.length === 0) {

          this.showSnackBar('Debe agregar el ACTA CONSTITUTIVA')
          return
        }
        if (this.ineRep === undefined || this.ineRep.length === 0) {
          this.showSnackBar('Debe agregar el Ine del representante legal')
          return
        }
        if (this.cartaOpinion === undefined || this.cartaOpinion.length === 0) {
          this.showSnackBar('Debe agregar la carta de opinion de cumplimiento')
          return
        }
        if (this.compDomicilio === undefined || this.compDomicilio.length === 0) {
          this.showSnackBar('Debe agregar el comprobante de domicilio')
          return
        }
        if (this.constSituacionFiscal === undefined || this.constSituacionFiscal.length === 0) {
          this.showSnackBar('Debe agregar la constancia de situacion fiscal')
          return
        }
        if (this.caratulaBanc === undefined || this.caratulaBanc.length === 0) {
          this.showSnackBar('Debe agregar la caratula bancaria')
          return
        }
      }

      this.alert = false
      if (this.rfcR === '' || this.nameR === '' || this.userR === '' || this.passR === '' || this.emailR === '') {
        this.showSnackBar('Complete los datos del formulario')
        return
      }
      const newUser = {
        usuario: this.userR,
        rfc: this.rfcR,
        nombre: this.nameR,
        contrasenia: this.passR,
        proveedor_id: this.proveedor_id,
        correo: this.emailR,
        tipo: this.tipoR
      }
      this.loadingRegister = true
      await axios.post('/usuario/register', newUser).then(resp => {
        const { data } = resp
        if (data.success) {
          if (!this.tieneDocs) {
            this.saveDocs(data)
          } else {
            this.loadingRegister = false
            localStorage.clear()
            localStorage.setItem('login', true)
            localStorage.setItem('tipoUser', data.data.tipo)
            localStorage.setItem('nombre', data.data.nombre)
            localStorage.setItem('email', data.data.correo)
            localStorage.setItem('id', data.data.id)
            localStorage.setItem('tipo_id', data.data.tipo_id)
            localStorage.setItem('rfc', data.data.rfc)
            localStorage.setItem('proveedor_id', data.data.proveedor_id)
            this.goToDash()
          }
        } else {
          this.loadingRegister = false
          this.showSnackBar(data.mensaje)
        }
      })
    },
    resetPass() {
      this.emailSend = ''
      this.dialogSendEmail = true
      this.alert = false
      this.alertS = false
      this.lectura = false
    },
    async sendEmail() {
      this.alert = false
      this.lectura = true
      if (this.emailSend === '') {
        this.alert = true
        this.showSnackBar('Debe agregar un correo')
        this.lectura = false
        return
      }
      await axios.post('/forgot-password', { email: this.emailSend }).then(resp => {
        const { data } = resp
        if (!data.success) {
          this.alert = true
          this.showSnackBar(data.message)
        } else {
          this.showSnackBar(data.message)
        }
         this.lectura = false
      })
    },
    showSnackBar(mensaje) {
      this.snackbar = true
      this.mensajeSnack = mensaje
    },
    pausarVideo() {
      //console.log('pausa')
      this.dialogVideo = false
      const iframe = this.$refs.videoIframe;
      const iframeContent = iframe.contentWindow;

      // Pausa el video dentro del iframe si es posible
      //if (iframeContent.postMessage) {
        iframeContent.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      //}
    },
    async saveDocs(data) {
      var formData = new FormData();

      formData.append('actaConstitutiva', this.actaConst);
      formData.append('ine', this.ineRep);
      formData.append('poderN', this.poderNota);
      formData.append('carta', this.cartaOpinion);
      formData.append('comprobante', this.compDomicilio);
      formData.append('constSituacion', this.constSituacionFiscal);
      formData.append('caraBancaria', this.caratulaBanc);
      formData.append('contratos', this.contratos);
      formData.append('id_usuario', data.data.id);
      formData.append('proveedor_id', data.data.proveedor_id)

      try {
        await axios.post('/proveedores/docs', formData).then(resp => {
          const json = resp
          this.loadingRegister = false
          if (json.data.success) {
            localStorage.clear()
            localStorage.setItem('login', true)
            localStorage.setItem('tipoUser', data.data.tipo)
            localStorage.setItem('nombre', data.data.nombre)
            localStorage.setItem('email', data.data.correo)
            localStorage.setItem('id', data.data.id)
            localStorage.setItem('tipo_id', data.data.tipo_id)
            localStorage.setItem('rfc', data.data.rfc)
            localStorage.setItem('proveedor_id', data.data.proveedor_id)
            this.goToDash()
          } else {
            this.showAlert(data.mensaje)
          }
        })
      } catch (e) {
        this.loadingRegister = false
      }
    }
  },
  created() {
    //console.log(!this.valid)
    if (this.$route.query.token) {
      this.updatePass(0)
    } else {
      this.dialog = false
    }
  },
  watch: {
    confirmP(value, oldValue) {
      if (value === this.updateP) {
        this.alert = false
        this.disabled = false
      } else {
        this.showAlert('Las contraseña no coinciden')
        this.disabled = true
      }
    },
    updateP(value, oldValue) {
      if (value === this.confirmP) {
        this.alert = false
        this.disabled = false
      } else {
        this.showAlert('Las contraseña no coinciden')
        this.disabled = true
      }
    },
    passR(value, oldValue) {
      if (value === this.passRC) {
        this.alert = false
        this.disabled = false
      } else {
        this.showAlert('Las contraseña no coinciden')
        this.disabled = true
      }
    },
    passRC(value, oldValue) {
      if (value === this.passR) {
        this.alert = false
        this.disabled = false
      } else {
        this.showAlert('Las contraseña no coinciden')
        this.disabled = true
      }
    }
  }
}
</script>

<style>

#inspire {
  height: 100%;
}
</style>
